import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'

export function DashboardRouter() {
    const Dashboard = lazy(() => import('../../pages/dashboard/Dashboard'))

    return (
        <Switch>
            <Route path='/painel/administrativo' component={Dashboard} />
        </Switch>
    )
}
